import { useEffect, useState } from "react";
import { VAR_TYPES } from "constants/constants";
import { FormattedMessage } from "react-intl";
import "./InputCheck.scss";

const InputCheck = ({ value, setValue, label, readOnly }) => {
  const [val, setVal] = useState(value || "");

  useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <div className="input-check">
      <div>
        <input
          type="checkbox"
          id={`input-check`}
          value={val}
          checked={value}
          onChange={() => {
            {
              if (!readOnly) {
                setValue(!value);
                setVal(!val);
              }
            }
          }}
        />
        <label for="input-check" />
        <p>
          {typeof label === VAR_TYPES.STRING ? (
            label
          ) : (
            <FormattedMessage
              id={label?.id}
              defaultMessage={label?.defaultMessage}
              style={{ fontWeight: "100" }}
            />
          )}
        </p>
      </div>
    </div>
  );
};

export default InputCheck;
